export default "__VITE_ASSET__Cb2gUt30__"